import { isFluxDuration } from '@/utils/isFluxDuration';

export const parseTimeRange = (start: string, stop: string | null) => {
  if (isFluxDuration(start)) {
    return {
      relativeTime: start,
    };
  } else {
    return { start: new Date(start).getTime(), stop: stop ? new Date(stop).getTime() : null };
  }
};
